import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import {
    EPostSessionQueryKeyBase as EQueryKeyBase,
    EPostSessionQueryUrl as EQueryUrl
} from "./post-session.modal.api.config"
import {
    type IPostSessionModuleReflectionQuestionsQueryDto as IModuleReflectionQuestionsQueryDto,
    type IPostSessionInitialDataDto
} from "./post-session.modal.api.types"

async function moduleReflectionQuestionsFetcher({
    queryKey
}: QueryFunctionContext<[EQueryKeyBase, string, string | undefined]>): Promise<IModuleReflectionQuestionsQueryDto> {
    const { data }: AxiosResponse<IModuleReflectionQuestionsQueryDto> = await axiosClient.get(
        EQueryUrl.ModuleReflectionQuestions({
            participantId: extractNumberFromQueryKeyPart(queryKey[1]),
            moduleId: extractNumberFromQueryKeyPart(queryKey[2])
        })
    )

    return data
}

async function reflectionInitialDataFetcher(): Promise<IPostSessionInitialDataDto> {
    const { data }: AxiosResponse<IPostSessionInitialDataDto> = await axiosClient.get(EQueryUrl.ReflectionInitialData())

    return data
}

export default {
    moduleReflectionQuestions: moduleReflectionQuestionsFetcher,
    reflectionInitialData: reflectionInitialDataFetcher
}
